import { Breakpoints, Carousel, useBreakpoint, useNextgenRouter, useSession } from '@nextgen-web-framework/all';
import { useEffect, useState } from 'react';
import { StorageService } from '@nextgen-web-framework/core';
import { IProduct, DerivedAvailabilityStatus } from '@commerce-product-webcomponents/sdk';
import { SearchCardLoader } from '@commerce-product-webcomponents/ui';
import { CheckoutProfile } from '@commerce-checkout-webcomponents/sdk';
import { CountdownTimer, getThemeColorClass, LocalStorageKeys, type ThemeColorType } from '@commerce-webcomponents/ui';
import { getProductsData } from '../../utils/product';
import styles from './ProductCarousal.module.scss';
import type { ProductCarousalProps } from './types/propsType';
import CarousalItem from './CarousalItem';

const ProductCarousal = (props: ProductCarousalProps) => {
  const viewPortType = useBreakpoint() as Breakpoints;
  const router = useNextgenRouter();
  const localStorage = StorageService.getLocalStorage();
  const [products, setProducts] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isApr, setIsApr] = useState<boolean>(false);
  const loadingProductLength = props.products?.length || props.slots || 5;
  const loadingProducts = Array.from({ length: loadingProductLength }, (_, i) => ({ id: i }));
  const productContainerBackgroundColor = props.themeColor
    ? getThemeColorClass(props.themeColor as ThemeColorType)
    : `container-background-color-${props?.backgroundColor}`;
  const { session } = useSession();

  useEffect(() => {
    const checkoutProfile = localStorage.retrieve(LocalStorageKeys.CHECKOUT_PROFILE) as unknown as CheckoutProfile;
    getProductsData({
      products: props.products ?? [],
      aprContainerKey: props.aprContainerKey ?? '',
      pageName: props.pageName ?? '',
      fulfillmentType: checkoutProfile?.fulfillmentType?.id,
      warehouseId: session?.warehouseId,
      filter: props.filter,
      channel: props.channel,
      slots: props.slots,
    })
      .then(({ products, isApr }) => {
        setLoading(false);
        setProducts(products);
        setIsApr(isApr);
      })
      .catch(() => {
        setProducts([]);
        setLoading(false);
      });
  }, [router.params?.locale, session?.warehouseId]);

  const { endTime = '', title } = props.countdownTimer ?? {};
  if (!loading && products.length === 0) {
    return <></>;
  }
  return (
    <div
      className={`${styles['product-carousal-container']} ${styles[productContainerBackgroundColor]}`}
      data-testid="product-caraousal-test-id"
    >
      <h4 className={styles['product-carousal-title']} data-testid="product-caraousal-title-id">
        {props.title}
      </h4>

      {endTime && <CountdownTimer endTime={endTime} title={title} customClass={styles['product-carousal-timer']} />}
      <Carousel
        id={`Product-Carousel${props.type}`}
        hideButtons={[Breakpoints.XS, Breakpoints.SM].includes(viewPortType)}
        isTileCarousel={true}
      >
        {loading
          ? loadingProducts?.map((p) => <SearchCardLoader key={p.id} />)
          : products
              .filter(
                (product) =>
                  product.derivedAvailabilityStatus !== DerivedAvailabilityStatus.OutOfStock &&
                  product.derivedAvailabilityStatus !== DerivedAvailabilityStatus.Nla,
              )
              .map((product) => (
                <div key={product?.productId} data-testid="carousel-item" className={styles['carousel-product-item']}>
                  <CarousalItem
                    productItem={product}
                    key={product.productId}
                    type={props.type}
                    showProductIdAndSizeComp={props.showProductIdAndSizeComp}
                    showVariantComp={props.showVariantComp}
                    showAddToCartButtonComp={props.showAddToCartButtonComp}
                    showAddToWishlistComp={props.showAddToWishlistComp}
                    isApr={isApr}
                  />
                </div>
              ))}
      </Carousel>
    </div>
  );
};
export default ProductCarousal;

export type { ProductCarousalProps };
